import mitt, { Emitter } from "mitt";
import { VueConstructor } from "vue";

declare module "vue/types/vue" {
  interface Vue {
    $mitt: Emitter<{ setAuthorizedFlag: void }>;
  }
}

export const mittUse = mitt();

const emitter = {
  install(Vue: VueConstructor): void {
    Vue.prototype.$mitt = mittUse;
  },
};

export default emitter;
